import { TrainingDocumentComponent } from '../../components/training/TrainingDocumentComponent';

export const TrainDocumentContainer = () => {
  return <TrainingDocumentComponent />;
};
